$(document).ready(function(){


  // setTimeout(function(){
  // $('.recurpay__onetime_radio').trigger('click');
  // },3000)


      




(function() {
  const observer = new MutationObserver(() => {
    const recurpayWidget = document.querySelector(".recurpay-pdp-widget");
    if (!recurpayWidget) return;


    const twoTimePurchase = recurpayWidget.querySelector(
      '.recurpay__widget_container[data-type="subscription-purchase"]'
    );

    if (!twoTimePurchase) return;
    if (twoTimePurchase.classList.contains("auto-triggered")) return;

    // console.log("Triggering two-time purchase automatically...");
    twoTimePurchase.click();
    twoTimePurchase.classList.add("auto-triggered");

    // Hide offer applied div
    const offerAppliedDiv = document.querySelector(".offer-applied-div");
    if (offerAppliedDiv) offerAppliedDiv.style.display = "none";

    // Clone additional offer info only once
    const additionalOfferDiv = document.querySelector(".offer-applied-div");
    const hiddenLiquidDiv = document.querySelector(".additional_offer_information");
    if (additionalOfferDiv && hiddenLiquidDiv && !additionalOfferDiv.parentNode.querySelector(".cloned-offer-info")) {
      const clone = hiddenLiquidDiv.cloneNode(true);
      clone.style.display = "block";
      clone.classList.add("cloned-offer-info");
      additionalOfferDiv.parentNode.insertBefore(clone, additionalOfferDiv.nextSibling);
      // console.log("Hidden offer information cloned");
    }

    // Select first dropdown frequency item
    const ul = document.querySelector(".dropdown-custom-frequency-list");
    if (!ul) return;

    const firstLi = ul.querySelector(".dropdown-custom-frequency-item");
    if (!firstLi) return;

    setTimeout(() => {
      firstLi.click();

      // Update prices
      const priceSpan = firstLi.querySelector("span:last-of-type");
      const price = priceSpan ? priceSpan.textContent : "0.00";

      const dropdownSelected = document.querySelector(".dropdown-custom-selected");
      if (dropdownSelected) {
        let dropdownPriceSpan = dropdownSelected.querySelector("span:last-of-type");
        if (!dropdownPriceSpan) {
          dropdownPriceSpan = document.createElement("span");
          dropdownSelected.appendChild(dropdownPriceSpan);
        }
        dropdownPriceSpan.textContent = price.toFixed(0);
      }

      const offerContainer = document.querySelector(".offer-price-container");
      if (offerContainer) offerContainer.textContent = price;

      // console.log("Offer price updated:", price);

    }, 500); // slight delay to allow dropdown to render

  });

  observer.observe(document.body, { childList: true, subtree: true });
})();





//   $('.description_tab_title2').click(function(){
//      $('.description_tab_title2').removeClass('active');
//     $(this).addClass('active');
//     // $('.description_tab_title2').not($(this)).removeClass('active');
//     // $('.main_description_container2').not($(this).parents('.product-faq').find('.main_description_container2')).slideUp();
//     // $(this).parents('.product-faq').find('.main_description_container2').slideToggle();
// })

//  $(document).on("click","img.icon.icon-close",function() {  
   $(document).on("click","svg.icon.icon-close",function() {  
    $('.menu-drawer-container').removeAttr('open');
    $('.header__icon--menu').attr('aria-expanded',false);
    $('body').removeClass('overflow-hidden-tablet');
});

const progressGoals = document.querySelectorAll('.docapp-fg-progress-goal');
 
progressGoals.forEach((div, index) => {
  // index + 1 because you want numbering starting from 1
  div.classList.add(`cstm-docapp-fg-goal-completed-${index + 1}`);
});

    document.querySelectorAll('.docapp-fg-pin-cropper').forEach(cropper => {
      const img = cropper.querySelector('img');
      if(img) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('your-new-class');
        cropper.insertBefore(newDiv, img);
      }
    });
    console.log('New div inserted above all images inside .docapp-fg-pin-cropper');
 
// 1000 milliseconds = 1 second delay

  $('.contact-query').click(function() {
    $(".contact-us-query-popup").fadeOut();
    var popupId = $(this).data('popup');
    $('#' + popupId).fadeIn();
    $("body").addClass("enable_contact_popup");
  });

  $('.contact-us-query-popup').click(function(event) {
    if ($(event.target).is('.contact-us-query-popup')) {
      $(this).fadeOut();
       $("body").removeClass("enable_contact_popup");
    }
  });

  $('.close-popup').click(function() {
    $(this).closest('.contact-us-query-popup').fadeOut();
     $("body").removeClass("enable_contact_popup");
  });






  
var banners = document.querySelectorAll('.banner-collection-sec');
    banners.forEach(function (banner) {
        if (banner.innerHTML.trim() === '') {
            banner.style.display = 'none';
        }
    });

  
         setTimeout(function(){
  var fullText = $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').text();
    var splitText = fullText.split('(');
    if (splitText.length > 1) {
        var beforeText = splitText[0];
        var afterText = '(' + splitText[1]; 
        var newText = beforeText + `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.357 7.12611C16.1344 6.90171 16.009 6.59881 16.0078 6.28277V5.21777C16.0069 4.57033 15.7493 3.94967 15.2914 3.49193C14.8335 3.0342 14.2128 2.77677 13.5653 2.7761H12.502C12.3454 2.77652 12.1903 2.74595 12.0455 2.68617C11.9008 2.62639 11.7693 2.53857 11.6587 2.42777L10.7503 1.5186C10.292 1.06143 9.67103 0.804688 9.02366 0.804688C8.37629 0.804688 7.75534 1.06143 7.29699 1.5186L6.38866 2.42777C6.27807 2.53872 6.14662 2.62669 6.00188 2.68662C5.85714 2.74654 5.70198 2.77724 5.54532 2.77694H4.48116C3.83371 2.7776 3.21296 3.03503 2.75507 3.49277C2.29718 3.9505 2.03954 4.57116 2.03866 5.2186V6.28277C2.03781 6.59848 1.91267 6.90115 1.69032 7.12527L0.780324 8.03444C0.323147 8.49278 0.0664063 9.11373 0.0664062 9.76111C0.0664062 10.4085 0.323147 11.0294 0.780324 11.4878L1.69032 12.3961C1.91287 12.6205 2.03828 12.9234 2.03949 13.2394V14.3044C2.04037 14.9519 2.29802 15.5725 2.75591 16.0303C3.2138 16.488 3.83455 16.7454 4.48199 16.7461H5.54532C5.70198 16.7458 5.85714 16.7765 6.00188 16.8364C6.14662 16.8964 6.27807 16.9843 6.38866 17.0953L7.29699 18.0044C7.75523 18.4618 8.37622 18.7187 9.02366 18.7187C9.6711 18.7187 10.2921 18.4618 10.7503 18.0044L11.6587 17.0953C11.7692 16.9843 11.9007 16.8964 12.0454 16.8364C12.1902 16.7765 12.3453 16.7458 12.502 16.7461H13.5662C14.2136 16.7454 14.8344 16.488 15.2922 16.0303C15.7501 15.5725 16.0078 14.9519 16.0087 14.3044V13.2394C16.0094 12.9235 16.1349 12.6207 16.3578 12.3969L17.267 11.4878C17.7242 11.0294 17.9809 10.4085 17.9809 9.76111C17.9809 9.11373 17.7242 8.49278 17.267 8.03444L16.357 7.12611Z" fill="#2196F3"></path>
<path d="M7.92726 12.7688C7.81943 12.7691 7.71262 12.7479 7.61303 12.7066C7.51344 12.6652 7.42305 12.6045 7.34711 12.528L5.15784 10.3387C5.01282 10.1831 4.93388 9.97724 4.93763 9.76455C4.94138 9.55187 5.02754 9.34894 5.17796 9.19852C5.32838 9.0481 5.5313 8.96194 5.74399 8.95819C5.95668 8.95444 6.16252 9.03339 6.31815 9.1784L7.92726 10.7864L11.7256 6.98914C11.8813 6.84412 12.0871 6.76517 12.2998 6.76893C12.5125 6.77268 12.7154 6.85884 12.8658 7.00926C13.0162 7.15967 13.1024 7.3626 13.1062 7.57529C13.1099 7.78798 13.031 7.99382 12.8859 8.14945L8.50741 12.528C8.43147 12.6045 8.34108 12.6652 8.24149 12.7066C8.1419 12.7479 8.03509 12.7691 7.92726 12.7688Z" fill="white"></path>
</svg>` + afterText;
        $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').html(newText);
    }
         },550);

 let swiper = new Swiper('.how-to-use-product-listing', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3.5,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
          breakpoints: {
        1200: {   
            slidesPerView: 3.2,
            spaceBetween: 10
        },
        992: {    
            slidesPerView: 2.5,
            spaceBetween: 20
        },
        749: {    // tablet
            slidesPerView: 2.2,
            spaceBetween: 20
        },
        // 480: {    // mobile
        //     slidesPerView: 2.3,
        //     spaceBetween: 10
        // },
        500: {    // mobile
            slidesPerView: 2.6,
            spaceBetween: 10
        }
        }
    });
    
    var initialTitle = $('.main_setps.active').data('title'); 
    $('.main-step-content-wrapper').each(function() {
        var contentTitle = $(this).data('title');
        if (contentTitle === initialTitle) {
            $(this).show(); 
        } else {
            $(this).hide();
        }
    });

    //original code start
  
    // $('.main_setps').click(function() {
    //     var title = $(this).attr('data-title');
    //     $('.main_setps').removeClass('active');
    //     $(this).addClass('active');
        
    //     $('.main-step-content-wrapper').each(function() {
    //         var contentTitle = $(this).attr('data-title');
    //                       $(".main-step-content-wrapper").hide();
    //         if (contentTitle === title) {
    //             $(this).show();  
    //             console.log('swiper = ', swiper);
                
    //           swiper.destroy(true, true);
    //           swiper = new Swiper('.how-to-use-product-listing', {
    //           loop: true,
    //           slidesPerView: 3.5,
    //           spaceBetween: 30,
    //         });
              
    //         } 
    //     });
    // });
    
    //original code end





//console error
 
$('.main_setps').click(function() {
    var title = $(this).attr('data-title');

    $('.main_setps').removeClass('active');
    $(this).addClass('active');

    $(".main-step-content-wrapper").hide();

    $('.main-step-content-wrapper').each(function() {
        var contentTitle = $(this).attr('data-title');

        if (contentTitle === title) {
            $(this).show();

            // Refresh existing swiper instead of destroying
            if (Array.isArray(swiper)) {
                swiper.forEach(function(instance) {
                    if (instance && typeof instance.update === 'function') {
                        instance.update();
                    }
                });
            }
        }
    });
});

 
//console error



    $('.main-step-content-wrapper').hide();
  if($(".main_setps .steps").hasClass("active")){
    $('.steps.active').each(function() {
        $(this).closest('.main_setps').trigger('click');
    });
  }else{
     $('.main-step-content-wrapper').first().show();
  }
    



  
 $('.subscription_custom_wrap .input-wrapper').click(function(){
    $('.input-wrapper').removeClass('checked')
    $(this).addClass('checked')
});


 $(document).on("click",".bottom-text-wraper",function() {
    $(".more-info-data-container").slideToggle();
       $(this).toggleClass('active');
  });

  var tag_fre_pro_attr= $('body').attr('free_pro_attr');
              var tag_fre_pro_id= $('body').attr('free-pro-data-attr');
             if(tag_fre_pro_attr == 'false'){
              $.ajax({
                          url: "/cart",
                          type: "GET",
                          dataType: "html",
                          success: function (t) {
                            $("cart-drawer-items").html($(t).find("cart-drawer-items").html());
                              $(".cart-item").each(function () {
                                var itemId = $(this).attr("item_id"); 
                             var fre_pro_line_item_attr = $(this).attr('fre_pro_attr');
                               if(fre_pro_line_item_attr){
                                  var deleted_pro_id = $(this).attr("item_id");
                                  jQuery.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                 async : false,
                                data: { quantity: 0,id: deleted_pro_id},
                                dataType: 'json',
                                  success: function (data) { 
                                  $.ajax({
                                   url: '/cart',
                                   type: "GET",
                                   dataType: "html",
                                       success: function(data) {
                                          $("#CartDrawer").html($(data).find('#CartDrawer').html());
                                            var productLenght = $('tr.cart-item').length;
                                           if(productLenght==0){
                                           $('cart-drawer.drawer').addClass('is-empty');
                                             $('#main-cart-footer').addClass('is-empty');
                                          $('cart-items.gradient').addClass('is-empty');
                                          }   
                                       $('.cart-count-bubble').html($(data).find('#CartDrawer .cart-item').length);
                                         $('.cart-count-bubble').html($(data).find('.cart-count-bubble').html());
                                          $('.cart__items').html($(data).find('.cart__items').html());
                                       },
                                    });
                                  }
                               })
                                }
                             });
          },
                      });
              }
                

$(document).on('click','.st-search-icon',function(){
$('.st-mobile-searchbox ').attr('style','display: block !important')
});
  $(document).on('click','.copied_content',function(){
     $('.copied').text('Copy Code');
$(this).parents('.coupon_code_list').find('.copied').text('Copied!');
  
});
   $(document).on("click",".collection ul.tabs li",function() {
       var Collectionlink = $(this).attr('collection-url');
      $(this).parents('.collection').find('a.link.underlined-link').attr('href',Collectionlink);
		var tab_id = $(this).attr('data-tab'); 
		$(this).parents('.collection').find('ul.tabs li').removeClass('current');
		$(this).parents('.collection').find('.tab-content').removeClass('current');
        $(this).parents('.collection').find('.tab-content').css('opacity','0');
         $(this).parents('.collection').find('.tab-content').fadeOut('slow');
        setTimeout(function(){
          window.dispatchEvent(new Event('resize'));
          $("#"+tab_id).fadeIn('slow');
           $("#"+tab_id).css('opacity','1');        
        },50);
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');    
	}); 
   $(document).on("click",".testimoniols-tab-link",function() {
    $('.custom-collection-tab').css('opacity','1')
    setTimeout(function(){window.dispatchEvent(new Event('resize'));},100)  
		var testimonials_tab_id = $(this).attr('testimonials-data-tab');
		$('.testimoniols-tab-link').removeClass('testimonials-current');
		$('.testimonials-current').removeClass('testimonials-current');
		$(this).addClass('testimonials-current');
		$("#"+testimonials_tab_id).addClass('testimonials-current');
	});
  var Swipes1 = new Swiper('.collection-swiper-container', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            480: {
                slidesPerView:'auto',
                spaceBetween: 10
            }
        }
    });
     var Swipes1 = new Swiper('.collection-swiper-container_new', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: true 
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            480: {
                slidesPerView:'auto',
                spaceBetween: 10,
                 scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
              draggable: false 
              },
            }
        }
    });
setTimeout(function(){$('body .custom-collection-tab').css('opacity','1')},700)
 var swiper2 = new Swiper('.swiper-container', {  
    pagination: {
         nextEl: '.testimonials-swiper-button-nextt',
         prevEl: '.testimonials-swiper-button-prevv',
       },
    pagination: '.swiper-pagination1, .swiper-pagination2',
      paginationClickable: true,
  });

if (window.matchMedia("(max-width: 749px)").matches){
    var Swipesc = new Swiper('.mobile-swiper-container', {   
        loop: false,       
        slidesPerView: 'auto',
        spaceBetween: 20,
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true
        }
    });
     var SwipesP = new Swiper('.icon-text-swiper', {   
        loop: false,       
        slidesPerView: 'auto',
        spaceBetween: 20,
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true
        } 
    });
  
}
  $(document).on("click",".read_more",function() { 
    $('.half_content').hide();
    $('.full_content').show();
  });
    $(document).on("click",".read_less",function() { 
    $('.half_content').show();
    $('.full_content').hide();
  });
  
 if (window.matchMedia("(max-width: 989px)").matches){ 
   
var heights = $(".collection-swiper-container ul").map(function ()
    {
        return $(this).height();
    }).get();

   
maxHeight = Math.max.apply(null, heights);
$('.collection-swiper-container ul li').css('height' , maxHeight);
  
  // $(document).on("click","a.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
  //   // $('.st-autocomplete-box-container').toggle();
  //   $('.st-autocomplete-box-container').show();
  // });

    $(document).on("click","span.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
     $('.st-autocomplete-box-container').toggle();
     $('body').toggleClass('st-no-scroll');
  });


   $(document).mouseup(function (e) {
     var popup = $(".st-autocomplete-box-container");
     if (!$('input#st-mobile-autocomplete-search-bar').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0 && !$('.st-searchicon').is(e.target)) {     
       popup.hide();
        $('body').removeClass('st-no-scroll');
       
     }
 });


 
   
 }

  
});

function copyToClipboard(element) {  
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();  
}





/*** Share button click Event ***/
$('#share-toggle-button,.share-button__button').click(function(){
  const userAgent = navigator.userAgent.toLowerCase();
  const isLinux = userAgent.includes('linux');
  const isFirefox = userAgent.includes('firefox');

  if (navigator.share && $(window).width() < 20067) {
    navigator.share({
      title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
      url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
    });
  } else {
    if ($(this).parents('.product-meta__share').find('.popover[open]').length > 0) {
      $(this).parents('.product-meta__share').find('.popover').removeAttr('open', false);
    } else {
      $(this).parents('.product-meta__share').find('.popover').attr('open', true);
    }
  }

  // Show .pdp_desk_share if OS is Linux OR browser is Firefox
  if (isLinux || isFirefox) {
    $('.pdp_desk_share').css('display', 'flex');
  }
});
 $('.popover__close-button').click(function(){
 $(this).parents('.popover').attr('open',false);
})
 
/*** Share button click Event END here***/
  /* hide popup outer from container */
   if($('body').hasClass('cstm-product') && $('.popover,.popover__header').length > 0){
   document.addEventListener('mouseup', function(e) {
    var container = $('.popover,.popover__header');
     console.log(e);
    if (!container.is(e.target) && !$(".close").is(e.target)) {
        var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
        $(container).attr('open',false)
    }
}); 
   }
  /* hide popup outer from container END*/



// Define the setCookie function globally
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

$(document).ready(function() {
    var modal = $("#myModal");
  var delay_range = parseInt(modal.attr('delay_range'));
  var delay_range_value = delay_range * 1000;
     var modalClosed = getCookie("modalClosed");
  var modalClosedd = getCookie("modalClosedd")
     if (!modalClosed && !modalClosedd && window.location.href.indexOf("challenge") <0) {
        setTimeout(function() {
        modal.css("display", "block");
        }, delay_range_value);
    }
  if(window.location.href.indexOf('form_type=customer') > -1 || window.location.href.indexOf('customer_posted=true') > -1){
    modal.css("display", "block");
    $('.newsletter-form__field-wrapper').hide();
        $('button#Subscribe').hide();
     $('.after_subscription_message').show();
      var after_sub_heading = $('.after_subscription_heading').text();
    var before_sub_heading =  $('#subs-heading').text(after_sub_heading);
    var after_sub_desc = $('.after_subscription_desc').text();
    var before_sub_desc =  $('#subs-desc').text(after_sub_desc);
   
  }
  function cookiesData(day_range,hours_range,range_type){
      if(range_type == 'days'){
          var totalMilliseconds = (day_range * 24 * 60 * 60 * 1000);
        } else{
          var totalMilliseconds = (hours_range * 60 * 60 * 1000);
        } 
        setCookie("modalClosed", true, totalMilliseconds); 
  }
$(".close").click(function() {
    var modal = $(this).closest('.modal'); 

    var day_range = parseInt(modal.attr('day_range')); 
    var hours_range = parseInt(modal.attr('hours_range')); 
    var range_type = modal.attr('data_range_type'); 
        modal.css("display", "none");
      cookiesData(day_range,hours_range,range_type);
     var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
});
$(window).click(function(event) {
    var modal =$('#myModal');
       var day_range = parseInt(modal.attr('day_range'));
      var hours_range = parseInt(modal.attr('hours_range'));
     var range_type = modal.attr('data_range_type'); 
        if ($(event.target).is("#myModal")) {
            modal.css("display", "none");
           cookiesData(day_range,hours_range,range_type);
        }
    });

function setCookie(name, value, milliseconds) {
    var expires = "";
    if (milliseconds) {
        var date = new Date();
        date.setTime(date.getTime() + milliseconds);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

    
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});
//========================== product-slider=============== //


  var mainSwiper;
var thumbSwiper;

function initProductSlider() {

  if (!$("body").hasClass('cstm-product')) return;

  // Destroy previous instances (important!)
  if (mainSwiper) mainSwiper.destroy(true, true);
  if (thumbSwiper) thumbSwiper.destroy(true, true);

  // THUMBS FIRST
  thumbSwiper = new Swiper('.carousel-main-new', {
    direction: 'vertical',
    slidesPerView: 4,
    spaceBetween: 10,
    initialSlide: 0,
    loop: false,
    freeMode: true,
    mousewheel: true,
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
  });

  // MAIN
  mainSwiper = new Swiper('.carousel-main', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    initialSlide: 0,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

}

document.addEventListener('DOMContentLoaded', function () {
  initProductSlider();

  let resizeTimer;

window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(function () {
    initProductSlider();
  }, 300);
});

});

$(document).ready(function() {
if($('.desktop_container .swiper-arrow-desktop').length > 0){
const carousel = document.querySelector('.desktop_container');
  const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
  const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');
   prev.style.display = 'none';
  next.style.display = 'none';
  carousel.addEventListener('mousemove', (e) => {
    const rect = carousel.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const half = rect.width / 2;
 
    // Position buttons at cursor location
    if (x < half) {
      prev.style.left = `${x}px`;
      prev.style.top = `${y}px`;
      prev.style.display = 'block';
      next.style.display = 'none';
    } else {
      next.style.left = `${x}px`;
      next.style.top = `${y}px`;
      next.style.display = 'block';
      prev.style.display = 'none';
    }
  });
 
  carousel.addEventListener('mouseleave', () => {
    prev.style.display = 'none';
    next.style.display = 'none';
  });
}

});




$(document).ready(function() {


  if ($('.cstm-product').length === 0) return;

  if ($('.desktop_container .swiper-arrow-desktop').length > 0) {
    const carousel = document.querySelector('.desktop_container');
    const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
    const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');

    prev.style.display = 'none';
    next.style.display = 'none';

    carousel.addEventListener('mousemove', (e) => {
      const rect = carousel.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const half = rect.width / 2;

      if (x < half) {
        prev.style.left = `${x}px`;
        prev.style.top = `${y}px`;
        prev.style.display = 'block';
        next.style.display = 'none';
      } else {
        next.style.left = `${x}px`;
        next.style.top = `${y}px`;
        next.style.display = 'block';
        prev.style.display = 'none';
      }
    });

    carousel.addEventListener('mouseleave', () => {
      prev.style.display = 'none';
      next.style.display = 'none';
    });
  }

});



$(document).ready(function() {
  if($(".new-swiper").length > 0){
  var swiper = new Swiper(".new-swiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,  // Default state for the scrollbar
      draggable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.9,
        spaceBetween: 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
        },
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          draggable: true,
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
          draggable: true,
        },
      },
    },
  });

  $(window).resize(function() {
    var windowWidth = $(window).width();
    if (windowWidth >= 1024) {
      swiper.params.scrollbar.hide = true;  
    } else {
      swiper.params.scrollbar.hide = false; 
    }
    swiper.update(); 
  });
}
});


$(document).ready(function() {
if($('.desktop_container .swiper-arrow-desktop').length > 0){
const carousel = document.querySelector('.desktop_container');
  const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
  const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');
   prev.style.display = 'none';
  next.style.display = 'none';
  carousel.addEventListener('mousemove', (e) => {
    const rect = carousel.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const half = rect.width / 2;
 
    // Position buttons at cursor location
    if (x < half) {
      prev.style.left = `${x}px`;
      prev.style.top = `${y}px`;
      prev.style.display = 'block';
      next.style.display = 'none';
    } else {
      next.style.left = `${x}px`;
      next.style.top = `${y}px`;
      next.style.display = 'block';
      prev.style.display = 'none';
    }
  });
 
  carousel.addEventListener('mouseleave', () => {
    prev.style.display = 'none';
    next.style.display = 'none';
  });
}
});




document.addEventListener('DOMContentLoaded', function() {
  const stickyCartBar = document.querySelector('#cstm-addtocart-sticky');
  const productForm = document.querySelector('.product-form');

  // Initially hide the sticky cart bar by removing the class or adding a hidden class
  // stickyCartBar.classList.remove('display_flex'); // or add 'display_none' if you want to use that
  
  if (stickyCartBar && productForm) {
    const handleScroll = () => {
      const formRect = productForm.getBoundingClientRect();

      if (formRect.bottom < 0) {
        stickyCartBar.classList.add('display_flex');   // show by adding class
        stickyCartBar.classList.remove('display_none'); // remove hidden class if any
      } else {
        stickyCartBar.classList.remove('display_flex'); // hide by removing class
        stickyCartBar.classList.add('display_none');   // add hidden class if you have one
      }
    };

    window.addEventListener('scroll', debounce(handleScroll, 10));
  }
});

$(document).ready(function () {
  $(document).on('click', function () {
    const opacity = parseFloat($('#custom-cursor').css('opacity'));

    if (opacity === 1) {
      $('.drawer').removeClass('active');
      $('body').removeClass('overflow-hidden');
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
// Step 0: Declare outside to use later if needed
if($("product-form.product-form input.product-variant-id").length > 0 && $('.variants_class').length > 0){
let selectedVariantId = null;
let selectedPrice = null;
let selectedCompareAtPrice = null;

// Step 1: Get selected variant ID
let selectedId = $("product-form.product-form input.product-variant-id").val();
// console.log("selectedId"+selectedId);
// Step 2: Parse variants JSON

let jsonText = $('.variants_class').text();

let variantsData = JSON.parse(jsonText);

// console.log(variantsData);

let selectedVariant;

if (Array.isArray(variantsData)) {
    // If it's an array, find the matching variant by id
    selectedVariant = variantsData.find(variant => variant.id == selectedId);
} else if (typeof variantsData === 'object' && variantsData !== null) {
    // If it's a single object (not an array), treat it like the first variant
    selectedVariant = variantsData;  // no need for [0], it's already the object
} else {
    // If variantsData is not an array or object (null or something else), handle it safely
    selectedVariant = null;
}

console.log(selectedVariant);

// Step 4: If match found, update values and DOM
if (selectedVariant) {
    selectedVariantId = selectedVariant.id;
    selectedPrice = selectedVariant.price;
    selectedCompareAtPrice = selectedVariant.compare_at_price;

    const formatMoney = (amount) => {
      return '₹' + (amount / 100).toFixed(2); 
    };

    const formattedPrice = formatMoney(selectedPrice);
    const formattedComparePrice = formatMoney(selectedCompareAtPrice);
    const saveAmountRaw = selectedCompareAtPrice - selectedPrice;
    const formattedSaveAmount = formatMoney(saveAmountRaw);

    const saveText = `You’ll save ${formattedSaveAmount}`;
    const stickyElement = document.getElementById("cstm-addtocart-sticky");

    console.log("Selected Variant ID:", selectedVariantId);
    console.log("Selected Price:", formattedPrice);
    console.log("Compare at Price:", formattedComparePrice);

if (stickyElement) {
    // Render into .price
    const priceElement = stickyElement.querySelector(".price");
    const comparePriceElement = stickyElement.querySelector(".compare-price");

    if (priceElement) {
      priceElement.textContent = formattedPrice;
    }

   const numericComparePrice = parseFloat(formattedComparePrice.replace(/[^\d.-]/g, ""));

// Now check if numericComparePrice is > 0
if (numericComparePrice > 0) {
  // Show compare price
  comparePriceElement.textContent = formattedComparePrice;
  comparePriceElement.style.display = "";
} else {
  // Hide compare price
  comparePriceElement.textContent = "";
  comparePriceElement.style.display = "none";
}

const saveTextElement = stickyElement.querySelector(".save_text");
if (saveTextElement) {
  if (saveAmountRaw > 0) {
    saveTextElement.textContent = saveText;
    saveTextElement.style.display = "";  // show element
  } else {
    saveTextElement.textContent = "";
    saveTextElement.style.display = "none";  // hide element
  }
}
} else {
    console.log("No variant found with ID:", selectedId);
}
}
}
//   // 🛒 Add to cart handler
  $('#add-to-cart-btn').off('click').on('click', function(e) {
    e.preventDefault();
    
    let selectedId = $("product-form.product-form input.product-variant-id").val();
    console.log(selectedId);
     const btn = $(this);
     btn.addClass('newLoad');

    setTimeout(function() {
      btn.removeClass('newLoad');
    }, 2000);

 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        quantity: 1,
        id: selectedId
      },
      success: function (data) {
        updateCartBubble()
        var $addToCart = $(this);
        $('#sticky_content').css('display','flex');

        setTimeout(function () {
          $('#sticky_content').css('display','none');
        }, 5000);
      
        $('body').trigger('added.ajaxProduct', $addToCart);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));

        jQuery.getJSON('/cart.js', function (cart, textStatus) {
          $("cart-drawer-items").html($(data).find("cart-drawer-items").html());
          $("#cart-icon-bubble").html($(data).find("#cart-icon-bubble").html());
          $("cart-drawer").removeClass("is-empty");
          $("drawer__inner-empty").hide();
          $("cart-drawer").load("/cart #CartDrawer");
        });
      },
      error: function (xhr, status, error) {
        console.log("Error adding to cart: ", error);
      }
    });
  });
function onload(){
    const overlay = document.getElementById('CartDrawer-Overlay');
      const cursor = document.getElementById('custom-cursor');
    
      overlay.addEventListener('mousemove', (e) => {
        cursor.style.opacity = '1';
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
      });
    
      overlay.addEventListener('mouseenter', () => {
        cursor.style.opacity = '1';
      });
    
      overlay.addEventListener('mouseleave', () => {
        cursor.style.opacity = '0';
      });
    };
  

});
  $('#view_cart').on('click', function (e) {
    e.preventDefault();

    // Animate and show cart
    setTimeout(function () {
        $(".drawer").addClass("animate active"); // Updated selector
    }, 1000);

    // Attach custom cursor events
    setTimeout(function () {
        const overlay = document.getElementById('CartDrawer-Overlay');
        const cursor = document.getElementById('custom-cursor');

        if (overlay && cursor) {
            // To prevent adding multiple event listeners
            if (!overlay.dataset.cursorSetup) {
                overlay.addEventListener('mousemove', (e) => {
                    cursor.style.opacity = '1';
                    cursor.style.left = e.clientX + 'px';
                    cursor.style.top = e.clientY + 'px';
                });

                overlay.addEventListener('mouseenter', () => {
                    cursor.style.opacity = '1';
                });

                overlay.addEventListener('mouseleave', () => {
                    cursor.style.opacity = '0';
                });

                // Mark as initialized
                overlay.dataset.cursorSetup = 'true';
            }
        } else {
            console.warn("Overlay or custom cursor element not found.");
        }
         let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
              console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1300);

    // Prevent scroll
    setTimeout(function () {
        $('body').addClass("overflow-hidden");
        let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
              console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1500);
});

function updateCartBubble() {
  let cartCount = null;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cartCount = cart.item_count;
      console.log("cartCount"+cartCount);
 
      const cartBubble = document.querySelector('.cart-count-bubble');
 
      if (cartCount > 0) {
        cartBubble.textContent = cartCount;
        cartBubble.classList.remove('hide');
      } else {
        cartBubble.classList.add('hide');
      }
    })
    .catch(error => console.error('Cart update error:', error));
}



 $(document).ready(function() {
  if($("body").hasClass('cstm-product') == false){
  var thumbSwiper = new Swiper('.carousel-main-new', {
    loop: false,
    slidesPerView: 5,
    spaceBetween: 15,

    grabCursor: true,
    thumbs: {
      swiper: mainSwiper,
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  breakpoints: {
      768: {
        slidesPerView: 3 ,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      }
    },
  });

  var mainSwiper = new Swiper('.carousel-main', {
    loop: false,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });

  }


// $(document).on('click', '.input-label-wrapper', function() {
//   var getImageurl = $(this).find('.variantfirstimg').attr('src');
//   getImageurl = getImageurl.replace(/&amp;/g, '&');
//   var cleanUrl = getImageurl.replace(/(&|\?)width=\d+/g, '');
//   $('.variant_specific_image img').attr('src', cleanUrl);
//    setTimeout(function() {
//       mainSwiper.slideTo(0);
//       thumbSwiper.slideTo(0);
//     }, 50);
// });


//to solve the console errors 

$(document).on('click', '.input-label-wrapper', function () {

  var getImageurl = $(this).find('.variantfirstimg').attr('src');

  if (!getImageurl) return;

  getImageurl = getImageurl.replace(/&amp;/g, '&');
  var cleanUrl = getImageurl.replace(/(&|\?)width=\d+/g, '');

  $('.variant_specific_image img').attr('src', cleanUrl);

  setTimeout(function () {

    // SAFE CHECK: prevent "undefined slideTo error"
    if (typeof window.mainSwiper !== "undefined" &&
        window.mainSwiper &&
        typeof window.mainSwiper.slideTo === "function") {
      window.mainSwiper.slideTo(0);
    }

    if (typeof window.thumbSwiper !== "undefined" &&
        window.thumbSwiper &&
        typeof window.thumbSwiper.slideTo === "function") {
      window.thumbSwiper.slideTo(0);
    }

  }, 50);

});

//to solve the console errors 


$(document).on('change', 'select[name="id"]', function() {
  var selectedVariantImage = $(this).find('option:selected').data('image-url');
  if(selectedVariantImage) {
    var cleanUrl = selectedVariantImage.replace(/&amp;/g, '&').replace(/(&|\?)width=\d+/g, '');
    $('.variant_specific_image img').attr('src', cleanUrl);
  }
});
var mySwiperInstance;
setTimeout(function(){

//********** location block slider start  *************/ 
 mySwiperInstance = new Swiper('.swiper-location-active', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 8,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
  pagination: {
          el: '.swiper-paginationjtpl',
          clickable: true,
          dynamicBullets: true
      },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar-jtpl",
          hide: true,
         draggable: true 
        },
        breakpoints: {
            1920: {
                slidesPerView: 3,
                spaceBetween: 8
            },
            982: {
                slidesPerView: 2,
                spaceBetween: 8
            },
            767: {
                slidesPerView: 1,
                spaceBetween: 8
            }
        }
    });
//********** location block slider end  *************/ 

//********** Review block image slider start  *************/ 
    var Swipes4 = new Swiper('.review-image-slider', {   
        loop: false,
        slidesPerView: 5,   
        paginationClickable: true,      
        spaceBetween: 13,
        navigation: {
        nextEl: '.swiper-button-next-jt',
        prevEl: '.swiper-button-prev-jt',
      },
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 10, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  }
    });
//********** Review block image slider end  *************/ 

//********** City block slider start  *************/ 
      var Swipes2 = new Swiper('.active-slider', {   
          loop: false,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          slidesPerView: 5.4,   
          paginationClickable: true,      
          spaceBetween: 16,
        // mousewheelControl: true,         
          freeMode: true,
        loopedSlides: 8, // according to the codepen
      followFinger: true,
    //     mousewheel: {
    //   releaseOnEdges: true,
    // },
    pagination: {
          el: '.swiper-pagination-jt',
          clickable: true,
          dynamicBullets: true
      },
      keyboard: {
      enabled: true, // enable keyboard navigation
      onlyInViewport: false, // allow keyboard outside the viewport
    },
          breakpoints: {
              1920: {
                  slidesPerView: 5.4,
                  spaceBetween: 16
              },
              1200: {
                  slidesPerView: 4.4,
                  spaceBetween: 16
              },
              767: {
                  slidesPerView: 3,
                  spaceBetween: 8
              }
          }
      });
//********** City block slider end  *************/ 

//********** State block slider start  *************/ 
  var Swipes3 = null;
    function initSwiper() {
  Swipes3 = new Swiper('.active-slider-state', {   
          loop: false,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          slidesPerView: 5.4,   
          paginationClickable: true,      
          spaceBetween: 16,
        // mousewheelControl: true,         
          freeMode: true,
        loopedSlides: 8, // according to the codepen
      followFinger: true,
    //     mousewheel: {
    //   releaseOnEdges: true,
    // },
      keyboard: {
      enabled: true, // enable keyboard navigation
      onlyInViewport: false, // allow keyboard outside the viewport
    },
          breakpoints: {
              1920: {
                  slidesPerView: 5.4,
                  spaceBetween: 16
              },
              1200: {
                  slidesPerView: 4.4,
                  spaceBetween: 16
              },
              767: {
                  slidesPerView: 3,
                  spaceBetween: 8
              }
          }
      });
    }
    initSwiper();
//********** State block slider end  *************/ 
  }, 500);
  setTimeout(function(){
    const style = document.createElement("style");
        style.textContent = `
          .city-content-main-wrapper {
              display: none;
          }
          .city-content-main-wrapper.active-state-one {
              display: block;
          }
          .location-wrapper-main{
            display: none;
          } 
          .location-wrapper-main.location-active{
            display: block;
          }
          .swiper-scrollbar-jtpl,
          .swiper-paginationjtpl{
            opacity: 0;
          }
          .location-active .swiper-scrollbar-jtpl{
            opacity: 1;
          }
          @media (max-width: 767px){
            .location-active .swiper-paginationjtpl{
              opacity: 1;
            }
          }
        `;
        document.head.appendChild(style);
    }, 700);
 
  $(".city-content-main-wrapper").each(function(){
      $(".city-content-main-wrapper").removeClass("active-state-one");
      $(".city-content-main-wrapper").first().addClass("active-state-one");
      $(".city-content-main-wrapper").first().trigger("click");
  });
  $(".location-wrapper-main").each(function(){
      $(".location-wrapper-main").removeClass("location-active");
      $(".location-wrapper-main").first().addClass("location-active");
      $(".location-wrapper-main").first().trigger("click");
  });

  //original code

    // $(".state-name").each(function(){
    //     $(this).click(function(){
    //       var stateName = $(this).attr("state-name");
    //         $(".state-name").removeClass("active-state");
    //         $(this).addClass("active-state");

    //         $(".city-content-main-wrapper").each(function(){
    //             var cityState = $(this).attr("state-name"); 
    //               // console.log(cityState);
    //             if(cityState == stateName){
    //                 $(".city-content-main-wrapper").removeClass("active-state-one");
    //                 $(this).addClass("active-state-one");
    //                 initSwiper();
    //                   $(".city-content-wrapper").removeClass("active-city");
    //                   // $(this).find(".city-content-wrapper").first().addClass("active-city");
    //                   $(this).find(".city-content-wrapper").first().trigger("click");
    //             }
    //           });
    //     });
    // });

    //original code


   // to solve the console error

            $(".state-name").on("click", function () {
            var stateName = $(this).attr("state-name");

            $(".state-name").removeClass("active-state");
            $(this).addClass("active-state");

            $(".city-content-main-wrapper").each(function () {
                var cityState = $(this).attr("state-name");

                if (cityState == stateName) {
                    $(".city-content-main-wrapper").removeClass("active-state-one");
                    $(this).addClass("active-state-one");

                    if (typeof initSwiper === "function") {
                        initSwiper();
                    }

                    $(this).find(".city-content-wrapper")
                          .removeClass("active-city")
                          .first()
                          .trigger("click");
                }
            });
        });

   // to solve the console error


    $(".city-content-wrapper").each(function(){
      $(".city-content-wrapper").first().trigger("click");
       $(this).click(function(){
          $(".city-content-wrapper").removeClass("active-city");
          $(this).addClass("active-city");
          var cityName = $(this).attr("city-name");
          // console.log("cityName"+ cityName);
          $(".location-wrapper-main").each(function(){
            var location = $(this).attr("location-name");
            // console.log("location"+ location);
            if(location == cityName){
              $(".location-wrapper-main").removeClass("location-active");
              $(this).addClass("location-active");
            }
        });
        
       });
    });
    $(".share-text-btn").each(function(){
      $(this).click(function(){
          if($(this).parents(".location-share-wrapper").find(".review-share-popup").hasClass("active-popup")){
              $(this).parents(".location-share-wrapper").find(".review-share-popup").removeClass("active-popup");
          }else{
          $(this).parents(".location-share-wrapper").find(".review-share-popup").addClass("active-popup");
          }
      }); 
    });
    $(document).click(function (e) {
        setTimeout(function () {
            if (!$(e.target).closest(".share-button__button").length && !$(e.target).closest(".pdp_desk_share").length) {
                $(".share-button details").removeAttr("open");
                $(".share-button details .share-button__button").attr("aria-expanded", "false");
            }
            if (!$(e.target).closest(".review-btn-slider").length && !$(e.target).closest(".review-image-jtpl").length) {
                 $("body").removeClass("review-popup-open");
                 $(".visit-us-review-popup-wrapper").remove();
            }
        }, 100);
    });

    $(".review-image-jtpl").click(function () {
      $("body").addClass("review-popup-open");
      $(".visit-us-review-popup-wrapper").remove();
      var allImages = $(this).parents(".review-image-slider")
        .find(".review-image-jtpl img");
    var clickedIndex = allImages.index($(this).find("img"));
    var slides = "";
    $(this).parents(".review-image-slider")
        .find(".review-image-jtpl img")
        .each(function () {
            var imgSrc = $(this).attr("src");

            slides += `
                <div class="swiper-slide">
                    <img src="${imgSrc}" alt="" loading="lazy" fetchpriority="auto" >
                </div>
            `;
        });
      $("body").append(`
          <div class="visit-us-review-popup-wrapper">
            <div class="visit-us-review-popup-inner">
                <div class="visit-us-review-popup-slider">
                    <div class="swiper-wrapper">
                        ${slides}
                    </div>
                    <div class="popup-slider-button review-btn-slider">
                      <div class="swiper-prev-review">
                        <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.1875 7.959L1.8125 4.58398L5.1875 1.20898" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="review-popup-close-btn review-btn-slider">
                        <span class="close-popup-review">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 12.75L12.75 0.75M0.75 0.75L12.75 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </span>
                      </div>
                      <div class="swiper-next-review review-btn-slider">
                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5625 7.31252L3.9375 3.9375L0.5625 0.5625" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <script>
            $(".close-popup-review").click(function(){
              $(".visit-us-review-popup-wrapper").remove();
              $("body").removeClass("review-popup-open");
            });
          </script>
      `);

      new Swiper('.visit-us-review-popup-slider', {   
        loop: false,
        slidesPerView: 'auto', 
        initialSlide: clickedIndex,  
        navigation: {
            nextEl: '.swiper-next-review',
            prevEl: '.swiper-prev-review',
        },        
        freeMode: true,
        loopedSlides: 10, 
        followFinger: true,
        spaceBetween: 13,
        keyboard: {
            enabled: true, 
            onlyInViewport: false, 
        },
        breakpoints: {
            767: {
                spaceBetween: 13
            }
        }
    });
    
});
var width = $(window).width();
 $(".review-image-slider .swiper-wrapper").each(function () {
      var slideC = $(this).find(".swiper-slide").length;

      if (slideC <= 5) {
          $(this).parents(".review-image-slider").find(".swiper-button-prev-jt").hide();
          $(this).parents(".review-image-slider").find(".swiper-button-next-jt").hide();
      }
  });
  $(".city-content-main-wrapper .swiper-wrapper").each(function () {
      var slideCo = $(this).find(".city-content-wrapper").length;

      if (width >= 768 && slideCo <= 5) {
         $(this).parents(".city-content-main-wrapper").find(".swiper-pagination-jt").hide();
          $(this).parents(".city-content-main-wrapper").addClass("swiper-slider-center");
      }

      if (width <= 768 && slideCo <= 3) {
          $(this).parents(".city-content-main-wrapper").find(".swiper-pagination-jt").hide();
          $(this).parents(".city-content-main-wrapper").removeClass("swiper-slider-center");
      }
  });
  $(".location-wrapper-main .swiper-wrapper").each(function () {
      var slideCount = $(this).find(".location-content-wrapper").length;
      if (width >= 768 && slideCount == 1 || width >= 768 && slideCount == 2) {
          $(this).parents(".location-wrapper-main").addClass("swiper-slider-center");
      }
      if (slideCount == 1) {
          $(this).parents(".location-wrapper-main").find(".swiper-paginationjtpl").hide();
      }
  });

  $(".visit-us-section-wrapper").css('opacity','1');
$(".visit-us-section-loaction-inner").css('opacity','1');
 const userAgent = navigator.userAgent.toLowerCase();
  const isLinux = userAgent.includes('linux');
  const isFirefox = userAgent.includes('firefox');
  const isandroid = userAgent.includes('android');
  if(isandroid){
    $(".ios-share-location").css("display", "flex");
  } else if(isLinux || isFirefox){
    $(".location-share-btn").show();
  }else{
    $(".ios-share-location").css("display", "flex");
  }
  
});



// function restructureGoKwikCart() {
//   document.querySelectorAll('.item.svelte-qc3127').forEach((item) => {
//     if (item.classList.contains('gk-restructured')) return;
//     const variantSelector = item.querySelector('.variant-selector');
//     const quantityHandler = item.querySelector('.quantity-handler');
//     const details = item.querySelector('.details');
//     const quantityWrapper = item.querySelector('.quantity-handler-wrapper');
//     const finalPrice = item.querySelector('.final-price');
//     const comparePrice = item.querySelector('.compare-at-price');
//     const discount = item.querySelector('.discount-percentage');
//     if (!variantSelector || !details) return;
//     let priceRow = document.createElement('div');
//     priceRow.className = 'custom-price-row';
//     if (finalPrice) priceRow.appendChild(finalPrice);
//     if (comparePrice) priceRow.appendChild(comparePrice);
//     if (discount) priceRow.appendChild(discount);
//     variantSelector.prepend(priceRow);
//     if (quantityHandler) {
//       details.appendChild(quantityHandler);
//     }
//     if (quantityWrapper) {
//       const removeBtn = quantityWrapper.querySelector('.remove-btn');
//       quantityWrapper.innerHTML = '';
//       if (removeBtn) {
//         quantityWrapper.appendChild(removeBtn);
//       }
//     }
//     item.classList.add('gk-restructured');
//   });
// }
// setTimeout(restructureGoKwikCart, 500);
// setTimeout(restructureGoKwikCart, 1200);
// setTimeout(restructureGoKwikCart, 2000);